module.exports = __webpack_public_path__ + "static/media/hiper_color.5cf99faa.png";